import { InjectionToken } from '@angular/core';

export interface FeatureFlagConfig {
	applicationStateStoreProxyService?: any;
}

export const InternalApplicationStateStoreProxyService = new InjectionToken<FeatureFlagConfig>('FeatureFlagConfig');
